
<style lang="less" scoped >
*{list-style-type: none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.headnav{width: 1200px;margin: auto;
  .title{width: 314px;line-height: 50px;border-bottom:3px solid #197dd3;font-size: 26px;font-weight: 700;}
}
.details{width: 1200px;margin: auto;display: flex;justify-content:space-between;
  .det_let{display: flex;flex-direction:column;margin-bottom: 30px;}
  .det_rig{display: flex;flex-direction:column;}
}
.card_top{width: 355px;height: 364px;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);border-radius: 4px;}
.card_bot{width: 355px;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);border-radius: 4px;margin-top:30px;
.el-button{width: 135px;height: 42px;font-size: 16px;border-radius: 5px;box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.16);margin-top: 10px;}
}
.rig_top_card{width: 820px;height: 484px;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);border-radius: 4px;margin-bottom: 30px;}
.rig_bot_card{width: 820px;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);border-radius: 4px;margin-bottom: 30px;}
.top_center{display: flex;justify-content:space-between;margin-top: -10px;}
/deep/.el-card__header{text-align: left; color: #333;}
.left{width: 90px;text-align: right;font-family: Microsoft YaHei;letter-spacing: 1px;font-weight: 600;}
.right{width: 220px;text-align: left;font-family: Microsoft YaHei;letter-spacing: 1px;
p:nth-child(3){width:230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
p:nth-child(5){width:230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}}
.rig_center{text-align: left;}
.content{margin: 0;text-align: left;line-height: 28px;}
.bot_center{margin: 0;padding: 0;display: flex;justify-content: space-between;margin-bottom:30px;
  li{width: 185px;border-radius: 4px;background-color: #eeeeee;
    img{width: 100%;height: 100px;}
    p{display: flex;flex-direction: column;margin: 0;text-align: left;padding: 5px 10px;font-size: 12px;line-height: 20px;color: #08032b;}
  }
}
.el-button{width: 135px;height: 42px;font-size: 16px;border-radius: 5px;box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.16);}
</style>
<template>
  <div class="center">
    <div class="headnav">
      <p class="title">电气石矿山供应</p>
    </div>
    <div class="details">
      <div class="det_let">
        <div class="card_top">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>卡片名称</span>
            </div>
            <div class="top_center">
              <div class="left">
                <p>产品类型：</p>
                <p>规格：</p>
                <p>单价：</p>
                <p>交易量：</p>
                <p>地区：</p>
                <p>有效期至：</p>
                <p>更新时间：</p>
              </div>
              <div class="right">
                <p>原矿</p>
                <p>其他</p>
                <p>电议</p>
                <p>大量</p>
                <p>石家庄</p>
                <p>2020-08-11</p>
                <p>2018-12-05</p>
              </div>
            </div>
          </el-card>
        </div>
        <div class="card_bot">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>卡片名称</span>
            </div>
            <div class="top_center">
              <div class="left">
                <p>联系人：</p>
                <p>电话：</p>
                <p>邮箱：</p>
                <p>手机：</p>
              </div>
              <div class="right">
                <p>原矿</p>
                <p>其他</p>
                <p>电议</p>
                <p>大量</p>
              </div>
            </div>
            <el-button>查看公司详情</el-button>
            <el-button>在线交谈</el-button>
          </el-card>
        </div>
      </div>
      <div class="det_rig">
        <div class="rig_top_card">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>卡片名称</span>
            </div>
            <div class="rig_center">
              <p style="margin:0" class="content">
                电气石晶体呈柱状，两端晶形不同,柱面上常出现纵纹,横断面呈弧线三角形。
                集合体呈棒状、放射状或致密块状。颜色随阳离子成分不同而异，富铁的黑电气石粉呈黑色，富锂、锰、铯的呈玫瑰色或深蓝色，富镁的呈褐、黄色,富铬的呈深绿色。
                此外, 电气石粉常沿柱体，或垂直柱体的横断面上形成不同颜色的色带。玻璃光泽;摩斯硬度7～7.5;比重3.03～3.25，随成分中铁、锰含量的增加而增大。电气石粉成分中富含挥发组分硼及水，成因多与气成作用有关，一般产于花岗伟晶岩中。也可作为变质矿物，产于电气石粉变粒岩中。还见于镁夕卡岩中，由交代作用形成。透明无瑕的电气石粉可作宝石，在中国称为碧玺;由于电气石粉有压电性，可用于测压仪表的元件。
              </p>
              <img src="static/images/zlkindex/矿业资讯.png" alt="" style="margin-top:20px">
            </div>
          </el-card>
        </div>
        <div class="rig_bot_card">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>卡片名称</span>
            </div>
            <ul class="bot_center">
              <li v-for="(each, index) in 4" :key="index">
                <img src="static/images/zlkindex/矿业资讯.png" alt="">
                <p>
                  <span>产品名：越南锌灰</span>
                  <span>单价：电议</span>
                  <span>地区：电议</span>
                </p>
              </li>
            </ul>
            <el-button>加载更多</el-button>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recommended from '../assembly/Recommended'
export default {
  components: {Recommended},
  name: '',
  data()
  {
    return {
      cardImgkyxmList: []
    }
  },
  computed: {
    CardImgkyxmList()
    {
      return this.cardImgkyxmList
    }
  },
  watch: {
  },
  created()
  {
    this.getProducts()
  },
  methods:
  {
    getProducts()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 12, _exp: 'id>0 and examine = 0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        ret[0].data.forEach(item =>
        {
          arr.push({pic: item.thumb ? item.thumb : 'static/images/moren.jpg', description: '产品名', title: item.title, price: item.price, area: item.address})
        })
        this.cardImgkyxmList = arr
      })
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/ProductView.vue